import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AppStore = lazy(() => import("@/pages/AppStore"));

export const Route = createFileRoute("/app")({
  component: AppStore,
});
